export const MULTI_VALUE_FILTER_CAMEL_KEYS = new Set([
  'mtrStructMainId',
  'mtrStructSubId',
  'status',
  'invStatus',
  'mtrKind',
  'manufacturerId',
  'warehouseId',
  'locationId',
  'countedWarehouseId',
  'currentWarehouseId',
  'anomalies',
  'abnormal',
  'bomStatus',
  'customerId',
  'currencyId',
]);

export const MULTI_VALUE_FILTER_SNAKE_KEYS = new Set([
  'mtr_struct_main_id',
  'mtr_struct_sub_id',
  'status',
  'inv_status',
  'mtr_kind',
  'manufacturer_id',
  'warehouse_id',
  'location_id',
  'counted_warehouse_id',
  'current_warehouse_id',
  'anomalies',
  'abnormal',
  'bom_status',
  'customer_id',
  'currency_id',
]);

export const DEFAULT_LIST_SORT_FIELD_LABELS = {
  code: '代號',
  name: '名稱',
};

export const MTR_LIST_SORT_FIELD_LABELS = {
  mtrNo: '料號',
  name: '名稱',
  sortKey: '排序鍵',
  status: '狀態',
  mtrKind: '物料類型',
  remark: '備註',
  originalSerialList: '原廠料號',
};

export function normalizeFilterValue(key, value) {
  if (!MULTI_VALUE_FILTER_CAMEL_KEYS.has(key)) {
    return value;
  }

  if (value === undefined || value === null || value === '') {
    return undefined;
  }

  return Array.isArray(value) ? value : [String(value)];
}

export function mergeFilterUpdate(filters, key, value) {
  const nextFilters = { ...filters };
  const normalized = normalizeFilterValue(key, value);
  const hasValue = Array.isArray(normalized) ? normalized.length > 0 : Boolean(normalized);

  if (hasValue) {
    nextFilters[key] = normalized;
  } else {
    delete nextFilters[key];
  }

  return nextFilters;
}
